module.exports = {"150821100":"隆兴昌镇","150821101":"塔尔湖镇","150821102":"套海镇","150821103":"新公中镇","150821104":"天吉太镇","150821105":"胜丰镇","150821106":"银定图镇","150821107":"复兴镇","150821200":"和胜乡","150821400":"巴彦淖尔市建丰农场","150821401":"内蒙古东土城劳动教养管理所"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150821.json
// module id = 460
// module chunks = 0